import {useCaptacionMap} from "abastecemento/captacion/hooks";
import {FormMapGeojsonPoint} from "base/component/form";
import {useOutletContext} from "react-router-dom";

const CaptacionFormLocationFields = ({isCreationForm = false}) => {
    let concello;
    [concello] = useOutletContext();

    const {mapConfig} = useCaptacionMap(isCreationForm ? concello : null);

    return (
        <FormMapGeojsonPoint
            name="geom"
            mapConfig={mapConfig}
            rules={{required: "O campo é obrigatorio"}}
        />
    );
};

export default CaptacionFormLocationFields;
